import React from 'react';
import './shc.css';
import Schdate from './schdate';

const groupByDate = (data) => {
  return data.reduce((acc, item) => {
    if (!acc[item.date]) {
      acc[item.date] = {
        day: item.day,
        events: []
      };
    }

    acc[item.date].events.push(item);
    return acc;
  }, {});
};

const Shc = ({ data }) => {
  const groupedSchedule = groupByDate(data || []);

  return (
    <div className="schwrapper">
      {Object.entries(groupedSchedule).map(([date, details]) => (
        <div className="schblock" key={date}>

          {/* DATE HEADER */}
          <div className="schheader">
            <h3>{date}</h3>
            <span>{details.day}</span>
          </div>

          {/* EVENTS */}
          <div className="schevents">
            {details.events.map((event) => (
              <Schdate
                key={event.id}
                schdate={event.time}
                n1={event.designer}
                n2={event.collection}
                placetext={event.location}
              />
            ))}
          </div>

        </div>
      ))}
    </div>
  );
};

export default Shc;